export default __webpack_public_path__ + "static/media/480_business04-nl-web.666c8cca.png";